import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { Token } from '../httpmethods';
import { RolesAPI } from '../api/RolesAPI';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [roles, setRoles] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setRoles(null);
    setIsAuthenticated(false);
  }, []);

  // Verificar autenticação apenas uma vez no mount
  useEffect(() => {
    const initializeAuth = async () => {
      const token = Token.get();
      
      if (token) {
        setIsAuthenticated(true);
        // Carregar roles apenas uma vez
        try {
          const response = await RolesAPI.getRoles();
          if (response.success) {
            setRoles(response.data.roles);
          } else {
            console.error('Erro ao carregar roles do usuário:', response.message);
          }
        } catch (error) {
          console.error('Erro ao carregar roles:', error);
        }
      } else {
        setIsAuthenticated(false);
        setRoles(null);
      }
      
      setLoading(false);
    };

    initializeAuth();
  }, []); // Array vazio - executa apenas uma vez

  const login = useCallback(async (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
    // Carregar roles após login
    try {
      const response = await RolesAPI.getRoles();
      if (response.success) {
        setRoles(response.data.roles);
      }
    } catch (error) {
      console.error('Erro ao carregar roles após login:', error);
    }
  }, []);

  const reloadRoles = useCallback(async () => {
    if (isAuthenticated) {
      try {
        const response = await RolesAPI.getRoles();
        if (response.success) {
          setRoles(response.data.roles);
        }
      } catch (error) {
        console.error('Erro ao recarregar roles:', error);
      }
    }
  }, [isAuthenticated]);

  const isAdmin = useMemo(() => {
    return roles && Array.isArray(roles) && roles.some(role => role.is_admin === true);
  }, [roles]);

  const value = useMemo(() => ({
    isAuthenticated,
    roles,
    loading,
    login,
    logout,
    isAdmin,
    reloadRoles
  }), [isAuthenticated, roles, loading, login, logout, isAdmin, reloadRoles]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};
